<template>
  <div>
    <div v-if="loading" class="loading">
      <SvgLoaderMoon> </SvgLoaderMoon>
    </div>
    <div v-else>
      <BackButton class="u-margin-bottom-small"> </BackButton>

      <div class="row h-full">
        <div class="col-sm-12 col-xl-5">
          <user-card :user="user" :showDeleteUser="showDeleteUser"> </user-card>
        </div>
        <div class="col-sm-12 col-xl-7">
          <edit-profile-form
            :user="user"
            :chosen_language="chosen_language"
            @update="updateName($event)"
            :disableAllowLogin="disableAllowLogin"
          >
          </edit-profile-form>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <credentials-form :user="user" :credentials="user.credentials" @updateUsername="updateUsername($event)">
          </credentials-form>

          <!-- Error Part -->
          <div v-if="catchedErrors" v-for="error in catchedErrors" v-bind:key="error">
            <p class="pt-3 text-custom_red text-sm">{{ error[0] }}</p>
          </div>
          <!-- End Errors Part -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosAuth from '../../../axiosMain';
import UserAvatar from '../../../components/UserAvatar';
import SvgEdit from '../../../components/svg/SvgEdit';
import ShowOrUpdateInput from '../../../components/Inputs/showOrUpdateInput';
import SvgLoaderMoon from '../../../components/svg/SvgLoaderMoon';
import BackButton from '../../../components/buttons/BackButton';
import ModalTemplate from '../../../components/modals/ModalTemplate';
import Multiselect from 'vue-multiselect';
import EditProfileForm from './EditProfileForm';
import UserCard from './UserCard';
import CredentialsForm from './CredentialsForm';
export default {
  name: 'UsersShow',
  components: {
    CredentialsForm,
    EditProfileForm,
    UserCard,
    ModalTemplate,
    BackButton,
    ShowOrUpdateInput,
    UserAvatar,
    SvgEdit,
    SvgLoaderMoon,
    Multiselect,
  },
  props: {
    disableAllowLogin: {
      type: Boolean,
      default: true,
    },
    showDeleteUser: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      languages: this.$store.getters.languages,
      chosen_language: null,
      user: null,
      user_credential: null,
      modal: false,
      password_modal: false,
      loading: true,
      edit_name: false,
      first_name: '',
      last_name: '',
      credential_id: null,
      credential_username: null,
      delete_credential_modal: false,
      credential_index: null,
      allow_log_in: null,
      catchedErrors: null,
    };
  },
  computed: {
    names: function () {
      return { first_name: this.user.first_name, last_name: this.user.last_name };
    },
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    setCredentialForDeletion: function (credential, index) {
      this.user_credential = credential.data;
      this.credential_index = index;
    },
    updateLanguage: function (event) {
      axiosAuth
        .post(
          '/users/' + this.$route.params.id,
          {
            language: event.language_code,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          localStorage.setItem('language', event.language_code);
          this.user = response.data.data;
          this.$store.dispatch('fetchAuthUser');
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_language_was_updated'),
          });
          this.$router.go(this.$router.currentRoute);
        })
        .catch((errors) => {
          Object.entries(errors.response.data).forEach((item) => {
            this.$notify({
              type: 'danger',
              title: item[1],
            });
          });
        });
    },
    getUserInfo: function () {
      axiosAuth
        .get('/users/' + this.$route.params.id)
        .then((response) => {
          var thisUser = response.data.data;
          this.allow_log_in = thisUser.allow_log_in;
          this.first_name = thisUser.first_name;
          this.last_name = thisUser.last_name;
          this.user = thisUser;
          this.$emit('set_user', this.user);
          this.loading = false;
        })
        .catch((errors) => {
          this.loading = false;
        })
        .finally((response) => {
          let language = localStorage.getItem('language');
          if (language) {
            this.chosen_language = this.languages[this.languages.findIndex((x) => x.language_code === language)];
          } else {
            this.chosen_language =
              this.languages[this.languages.findIndex((x) => x.language_code === this.user.language)];
          }
        });
    },
    authUserHasScope: function (scopeName) {
      let scopes = this.$store.getters.userScopes;
      return scopes.includes(scopeName);
    },
    updateAllowLogIn: function (allowLogIn) {
      axiosAuth
        .patch(
          '/update_allow_log_in/' + this.$route.params.id,
          {
            allow_log_in: allowLogIn,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.$notify({
            type: 'success',
            title: 'Success!',
            text: 'Allow login was updated!',
          });
        })
        .catch((errors) => {
          Object.entries(errors.response.data).forEach((item) => {
            this.$notify({
              type: 'danger',
              title: item[1],
            });
          });
        });
    },
    updateName: function (event) {
      this.edit_name = false;
      axiosAuth
        .post('/users/' + this.$route.params.id, event, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.user.first_name = response.data.data.first_name;
          this.user.last_name = response.data.data.last_name;
          this.$store.dispatch('fetchAuthUser');
          this.$notify({
            type: 'success',
            title: 'Success!',
            text: 'Name was updated',
          });
        })
        .catch((errors) => {
          Object.entries(errors.response.data).forEach((item) => {
            this.$notify({
              type: 'danger',
              title: item[1],
            });
          });
        });
    },
    updateUsername: function (event) {
      this.catchedErrors = null;
      axiosAuth
        .patch('/credentials/' + event.data.credential_id, event.data, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.loading = false;
          this.$notify({
            type: 'success',
            title: 'Success!',
            text: 'Your username was updated',
          });
        })
        .catch((errors) => {
          this.loading = false;
          this.catchedErrors = errors.response.data.errors;
          Object.entries(errors.response.data).forEach((item) => {
            this.$notify({
              type: 'danger',
              title: item[1],
            });
          });
        });
    },
    cancelUpdateUsername: function () {
      this.edit_name = false;
      this.first_name = this.user.first_name;
      this.last_name = this.user.last_name;
    },
    deleteCredential: function () {
      axiosAuth
        .delete('/credentials/' + this.user_credential.credential_id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.removeCredential();
          this.$notify({
            type: 'success',
            title: 'success!',
            text: 'Credentials were deleted!',
          });
        })
        .catch((errors) => {
          Object.entries(errors.response.data).forEach((item) => {
            this.$notify({
              type: 'danger',
              title: item[1],
            });
          });
        });
    },
    removeCredential: function () {
      this.user.credentials.splice(this.credential_index, 1);
    },
  },
};
</script>

<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped></style>
